import { Injectable } from "@angular/core";
import { RestReadServiceBase } from "@definitiv-packages/angular-dba-library";
import { SicherungssystemModelView } from "../../types/SicherungssystemModel";

@Injectable({
    providedIn: 'root'
})
export class SicherungssystemViewService extends RestReadServiceBase<SicherungssystemModelView> {
    constructor(
    ) {
        super("SicherungssystemModelView", false);
    }
}